import {Button, COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const ArrowButton: React.FC<React.PropsWithChildren> = ({children}) => {
  return (
    <StyledButton withBorder disableShadow type="secondary">
      {children}
      <Icon fill={COLORS.Grey2} size="XS" asset={GenericIconName.ArrowRight} />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px;
  text-align: left;
`;
